import React from 'react';
import { inject, observer } from 'mobx-react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';

import Controller from '../../components/Controller';

import { __ } from '../../i18n';

@graphql(gql`mutation deleteEntity($deleteEntityMutation: DeleteEntityInput!) {
  deleteEntity(input: $deleteEntityMutation) {
    clientMutationId
  }
}`, {
  options: {
    refetchQueries: ['OrganizationEntitiesQuery']
  }
})
@inject('store') @observer
export default class EntityDelete extends Controller {
  request = () => this.props.mutate({
    variables: {
      deleteEntityMutation: {
        id: this.props.params.entity_id
      }
    }
  }).then(() => {
    this.props.store.snackbar = { active: true, message: __('Person was deleted'), success: true };
    this.props.router.push(`/organizations/${this.props.params.organization_id}/entities`);
  })

  render() {
    return (
      <Controller
        id="EntityDelete"
        delete
        object={__('person')}
        onSubmit={this.onSubmit}
        {...this.props}
      />
    );
  }
}
